import { BeckyModelFactory } from '../../types/becky'

export const typedModelFactory = <Model>(modelFactory: any): BeckyModelFactory<Model> => {
	return modelFactory
}
